<template>
  <div class="hero-course-wrap bg-offwhite newtheme-cart-component">
    <div class="container container-coursedetail transaction-banner">
      <div  class="hero-course-con py-5">
        <h2 class="font-weight-bold mb-3 mt-4">Invoice</h2>
      </div>
    </div>
  </div>
  <div v-if="transaction" id="frontend">
    <div class="m-5">
      <div class="card-body">
        <h4 class="font-weight-bold mt-4 mb-3">Transaction Details</h4>
        <div class="course_box_container">
          <div class="course-box back_ground">
            <div class="cart-img-name-text">
              <div>
                <!-- TRX ID can be added here if needed -->
                <p><b>Status:</b> {{ transaction.status }}</p>
                <p><b>For:</b> {{ transaction.for }}</p>
                <p><b>Details:</b> {{ transaction.details }}</p>
                <p><b>Sub Total:</b> {{ transaction.amount <= 0 ? 0 : subtotal }}</p>
                <p><b>Process Fee:</b> {{ transaction.amount <= 0 ? 0 : processFee }}</p>
                <p><b>Total:</b> {{ transaction.amount <= 0 ? 0 : transaction.amount }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="transaction.slots && transaction.slots.length > 0" class="card-body">
        <h4 class="font-weight-bold mt-4 mb-3">Order Details</h4>
        <div v-for="slot in transaction.slots" :key="slot.id" class="course_box_container">
          <div class="course-box back_ground">
            <div class="cart-img-name-text">
              <div class="d-flex w-100">
                <div v-if="slot.slot.tutor" class="course-box-content setWidth">
                  <p class="fontsize-21-25">Session Date/time: {{ formatSessionTime(slot.slot.start_date_time, slot.slot.end_date_time) }}</p>
                  <p class="fontsize-21-25">Tutor Name: <router-link :to="'/tutor/' + slot.slot.tutor.id">{{ slot.slot.tutor.name }}</router-link></p>
                  <p class="fontsize-21-25">Session Fee: {{ slot.slot.price }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import axiosInstance from "@/assets/js/axios";
import endpoints from "@/assets/js/api";

export default {
    name: "ShowInvoice",
    components: {},
    props: [],
    data() {
      return {
        transaction: null,
        subtotal: 0,
        processFee: 0,
      };
    },
    async mounted() {
      this.getTransactionDetails();
    },
    async created() {

    },
    methods: {
      getTransactionDetails() {
        const transId = this.$route.params.trx_id;
        axiosInstance.get(endpoints.getTransactionDetailRoute, {params: {trx_id:transId}})
            .then(response => {
              console.log(response);
              this.transaction = response.data.data.transaction;
              this.calculateAmounts();
            })
            .catch(error => {
              console.error('Error fetching transaction details:', error);
            });
      },
      calculateAmounts() {
        if (this.transaction.amount > 0) {
          this.subtotal = this.transaction.amount - (this.transaction.amount * 0.1); // Example calculation
          this.processFee = this.transaction.amount - this.subtotal;
        }
      },
      formatSessionTime(start, end) {
        const startTime = moment(start).format('DD MMM h:mm A');
        const endTime = moment(end).format('DD MMM h:mm A');
        return `${startTime} - ${endTime}`;
      }
    },
};
</script>

<style scoped>
body,
html {
    overflow-x: hidden;
}
.customBox {
    border-radius: 16px;
    box-shadow: none !important;
}
.book_trial_lesson {
    width: 100%;
    border-radius: 12px;
    background: rgba(62, 0, 97, 0.79);
    padding: 10px 0;
    color: white;
    outline: none;
    border: none;
    font-weight: bold;
}
.book_trial_lesson.disabled {
    background: rgba(0, 0, 0, 0.5);
    cursor: not-allowed;
}
.text-dark {
    color: #090f19 !important;
}
.profile-img img {
    border-radius: 15px !important;
}
.arrow_btn {
    font-size: 20px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.3);
    outline: none;
    padding: 0px 10px;
    background: white;
}
</style>
